import React, { useState, useEffect, useContext } from 'react';
import { useForm } from "react-hook-form"

import { Box, Select, Option } from '@mui/joy';
import { default as ReactApexChart } from 'react-apexcharts'
import { useTranslation } from 'react-i18next'
import { useFormatter } from "../../utils";
import { Tag } from "../Snippet";
import { Icon, IconButton } from "../../assets";
import { useDataProvider } from '../../../mtska-frontend-data-provider';
import { useDrawer } from "../Drawer";
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { useConstAndReimbursement } from '../../utils';

const VehicleKilometer = ({ item, contractStartDate, contractEndDate, contractMonths, contractKilometers, contractCostKMExcess, contractKMReimbursement, contractPercentage1, contractCostKMExcess2, contractKMReimbursement2, contractPercentage2, contractCostKMExcess3, contractKMReimbursement3, contractPercentage3, contractCostKMCurrency, contractKmDeductible, contractInitialMileage, contractMaxReimbursementAmount, tracingSerie, tracingSerieRedraw }) => {
    const { t, i18n } = useTranslation();
    const { formatCurrency, formatDistance } = useFormatter();
    const { calculate } = useConstAndReimbursement();
    const { activate } = useDrawer();
    const { userCapabilities } = useContext(AppContext);

    contractMonths = parseInt(contractMonths);
    contractKilometers = parseInt(contractKilometers);
    contractCostKMExcess = parseFloat(contractCostKMExcess) || 0;
    contractKMReimbursement = parseFloat(contractKMReimbursement) || 0;
    contractPercentage1 = parseFloat(contractPercentage1) || 0;
    contractCostKMExcess2 = parseFloat(contractCostKMExcess2) || 0;
    contractKMReimbursement2 = parseFloat(contractKMReimbursement2) || 0;
    contractPercentage2 = parseFloat(contractPercentage2) || 0;
    contractCostKMExcess3 = parseFloat(contractCostKMExcess3) || 0;
    contractKMReimbursement3 = parseFloat(contractKMReimbursement3) || 0;
    contractPercentage3 = parseFloat(contractPercentage3) || 0;
    contractKmDeductible = parseInt(contractKmDeductible) || 0;
    contractInitialMileage = parseInt(contractInitialMileage) || 0;
    const parsedContractMaxReimbursementAmount = parseInt(contractMaxReimbursementAmount);
    const hasContractMaxReimbursementAmount = !isNaN(parsedContractMaxReimbursementAmount) && parsedContractMaxReimbursementAmount > 0;
    contractMaxReimbursementAmount = hasContractMaxReimbursementAmount ? parsedContractMaxReimbursementAmount * -1 : 0;

    const calculateEndDate = (contractStartDate, contractMonths) => {
        const cedcalc = (new Date(contractStartDate));
        cedcalc.setMonth(cedcalc.getMonth() + parseInt(contractMonths));
        return cedcalc;
    }

    const { loadOne } = useDataProvider('cars/car');
    const handleRefineContract = () => {
        activate('contracts/detail', {
            id: item?.contract?.id,
            defaultValue: item?.contract,
            filters: item?.contract,
        }, () => loadOne(item?.id));
    };

    // oggi
    const [td, setTd] = useState();

    // data di inizio contratto
    const [csd, setCsd] = useState();

    // data di fine contratto
    const [ced, setCed] = useState();

    // data ultimo rilevamento kilometrico
    const [ltd, setLtd] = useState();

    // valore ultimo rilevamento kilometrico
    const [ltv, setLtv] = useState();

    // data penultimo rilevamento kilometrico
    const [stltd, setStltd] = useState();

    // valore penultimo rilevamento kilometrico
    const [stltv, setStltv] = useState();

    // giorni totali di contratto
    const [totdays, setTotDays] = useState();

    // giorni da inizio a last trace date
    const [ltdays, setLtDays] = useState();

    // giorni da last trace date a fine
    const [remdays, setRemDays] = useState();

    // giorni da penultima a last trace date
    const [stldeltadays, setStlDeltaDays] = useState();

    // delta km da penultima a last trace date
    const [stldeltav, setStlDeltav] = useState();

    // km al giorno da contratto
    const [km_day_contract, setKmDayContract] = useState();

    // km al giorno attuali
    const [km_day_actual, setKmDayActual] = useState();

    // km al giorno attuali
    const [km_day_corrective, setKmDayCorrective] = useState();

    // km al giorno da penultimo rilevamento
    const [km_day_secondtolast, setKmDaySecondtolast] = useState();

    // km proiezione actual
    const [km_total_forecast_actual_day, setKmTotalForecastActualDay] = useState();

    // km proiezione contract
    const [km_total_forecast_contract_day, setKmTotalForecastContractDay] = useState();

    // km proiezione corrective
    const [km_total_forecast_corrective_day, setKmTotalForecastCorrectiveDay] = useState();

    // km proiezione da penultimo rilevamento
    const [km_total_forecast_secondtolast_day, setKmTotalForecastSecondtolastDay] = useState();

    // mesi da ultimo rilevamento a fine contratto
    const [months_from_lasttrace_to_end, setMonthsFromLasttraceToEnd] = useState();

    // km totali previsti
    const [km_total_forecast, setKmTotalForecast] = useState();

    // km al mese previsti
    const [km_month_forecast, setKmMonthForecast] = useState();

    // costo km eccesso
    const [km_cost_forecast, setKmCostForecast] = useState();

    // km al mese da contratto
    const [km_month_contract, setKmMonthContract] = useState();

    // km al mese effettivi
    const [km_month_actual, setKmMonthActual] = useState();

    // km al mese correttivi
    const [km_month_corrective, setKmMonthCorrective] = useState();

    // km al mese dal penultimo rilevamento
    const [km_month_secondtolast, setKmMonthSecontolast] = useState();

    // strategia di riempimento della serie di rilevamenti futuri
    const [forecastStrategy, setForecastStrategy] = useState("actual");

    // serie da disegnare
    const [series, setSeries] = useState();

    // options di Apex
    const [options, setOptions] = useState();

    // drawable (dati pronti)
    const [drawable, setDrawable] = useState(false);

    const [contractSerie, setContractSerie] = useState();
    const [forecastSerie, setForecastSerie] = useState();

    useEffect(() => {
        //console.info('effectone base')
        if (!tracingSerie) return;
        if (tracingSerie && tracingSerie[0]?.traced_at && tracingSerie[1]?.traced_at) {
            tracingSerie = tracingSerie.sort((a, b) => new Date(b.traced_at) - new Date(a.traced_at));
        }
        //console.info('effectone base OK')

        const td = new Date();
        const csd = new Date(contractStartDate);
        const ced = contractEndDate ? new Date(contractEndDate) : calculateEndDate(contractStartDate, contractMonths);
        const ltd = new Date(tracingSerie[0]?.traced_at);
        const ltv = tracingSerie[0]?.value;
        const stltd = new Date(tracingSerie[1]?.traced_at);
        const stltv = tracingSerie[1]?.value;

        const ltdays = (ltd - csd) / (1000 * 60 * 60 * 24);
        const remdays = (ced - ltd) / (1000 * 60 * 60 * 24);
        const stldeltadays = (ltd - stltd) / (1000 * 60 * 60 * 24);
        const stldeltav = ltv - stltv;
        const totdays = (ced - csd) / (1000 * 60 * 60 * 24);

        const km_day_contract = contractKilometers / totdays;
        const km_day_actual = ltv / ltdays;
        const km_day_corrective = (contractKilometers - ltv) / (totdays - ltdays);
        const km_day_secondtolast = stldeltav / stldeltadays;

        const km_total_forecast_actual_day = ltv + (remdays * km_day_actual);
        const km_total_forecast_contract_day = ltv + (remdays * km_day_contract);
        const km_total_forecast_corrective_day = ltv + (remdays * km_day_corrective);
        const km_total_forecast_secondtolast_day = ltv + (remdays * km_day_secondtolast);

        const monthsFromLasttraceToEnd = ced.getMonth() - ltd?.getMonth() + (12 * (ced.getFullYear() - ltd?.getFullYear())) - 1;

        const km_month_contract = km_day_contract * (365 / 12);
        const km_month_actual = km_day_actual * (365 / 12);
        const km_month_corrective = km_day_corrective * (365 / 12);
        const km_month_secondtolast = km_day_secondtolast * (365 / 12);

        setTd(td);
        setCsd(csd);
        setCed(ced);
        setLtd(ltd);
        setLtv(ltv);
        setStltd(stltd);
        setStltv(stltv);
        setLtDays(ltdays);
        setRemDays(remdays);
        setStlDeltaDays(stldeltadays);
        setStlDeltav(stldeltav);
        setTotDays(totdays);
        setKmDayContract(km_day_contract);
        setKmDayActual(km_day_actual);
        setKmDayCorrective(km_day_corrective);
        setKmDaySecondtolast(km_day_secondtolast);
        setKmTotalForecastActualDay(km_total_forecast_actual_day);
        setKmTotalForecastContractDay(km_total_forecast_contract_day);
        setKmTotalForecastCorrectiveDay(km_total_forecast_corrective_day);
        setKmTotalForecastSecondtolastDay(km_total_forecast_secondtolast_day);
        setMonthsFromLasttraceToEnd(monthsFromLasttraceToEnd);
        setKmMonthContract(km_month_contract);
        setKmMonthActual(km_month_actual);
        setKmMonthCorrective(km_month_corrective);
        setKmMonthSecontolast(km_month_secondtolast);
    }, [forecastStrategy, tracingSerieRedraw]);


    useEffect(() => {
        //console.info('effect options')
        if (!ced) return;
        //console.info('effect options OK')

        setOptions({
            chart: {
                width: '100%',
                height: '240px',
                toolbar: {
                    autoSelected: "pan",
                    //show: false
                },
                // zoom: {
                //     enabled: false,
                // },
                fontFamily: 'Inter, Helvetica, Arial, sans-serif',
                defaultLocale: i18n.resolvedLanguage,
                locales: [{
                    name: i18n.resolvedLanguage,
                    options: {
                        months: [t('January'), t('February'), t('March'), t('April'), t('May'), t('June'), t('July'), t('August'), t('September'), t('October'), t('November'), t('December')],
                        shortMonths: [t('Jan'), t('Feb'), t('Mar'), t('Apr'), t('May_'), t('Jun'), t('Jul'), t('Aug'), t('Sep'), t('Oct'), t('Nov'), t('Dec')],
                    }
                }]
            },
            forecastDataPoints: {
                //count: months_from_lasttrace_to_end
            },
            xaxis: {
                type: 'datetime',
                labels: {
                    style: {
                        colors: ['#9FA6AD'],
                        fontSize: '11px',
                        fontWeight: 400
                    }
                }
            },
            yaxis: {
                labels: {
                    style: {
                        colors: ['#9FA6AD'],
                        fontSize: '11px',
                        fontWeight: 400
                    }
                }
            },
            colors: ["#51BC51", "#0BA5EC"],

            markers: {
                size: [1, 2],
                strokeColors: ["#51BC51", "#0BA5EC"],
                strokeWidth: [1, 1],
                colors: ["#FFF", "#FFF"],
                // discrete: [
                //         {
                //             seriesIndex: 1,
                //             dataPointIndex: tracingSerie?.length - 1,
                //             fillColor: '#FFF',
                //             strokeColor: '#FF0000',
                //             size: 6,
                //             shape: "circle"
                //         }
                //     ]
            },
            stroke: {
                width: [1, 1],
                curve: 'straight'
            },
            legend: {
                show: false,
            },
            fill: {
                type: "gradient",
                gradient: {
                    opacityFrom: 0.4,
                    opacityTo: 0,
                    stops: [0, 100],
                    type: "vertical",
                    shadeIntensity: 0.5,
                }
            },
            dataLabels: {
                enabled: false,
            },
            annotations: {
                xaxis: [
                    {
                        x: new Date().getTime(),
                        borderColor: '#9FA6AD',
                        strokeDashArray: 0
                    },
                    {
                        x: new Date().getTime(),
                        x2: new Date(ced).getTime(),
                        fillColor: '#F0F4F8',
                    }
                ]
            }
        });
    }, [ced])

    useEffect(() => {
        //console.info('effect contractSeries')
        if (!csd || !ced || !km_month_contract || !contractMonths) return;
        //console.info('effect contractSeries OK')

        // creo la serie basata sul contratto
        const contract_serie = [];
        //console.info('contractMonths', contractMonths);
        //console.info('-----------')
        for (let i = 0; i < contractMonths; i++) {
            let d = (new Date(csd));
            d.setMonth(csd.getMonth() + i);

            //console.info("contract iteration "+i+" "+contractMonths, { x: d, y: km_month_contract * i })
            contract_serie.push({ x: d.getTime(), y: parseInt(km_month_contract * i), date: d, iterator: i });
        }
        // inserisco l'ultimo record manualmente per farlo corrispondere esattamente alla fine del contratto
        contract_serie.push({ x: ced.getTime(), y: parseInt(km_month_contract * contractMonths), date: ced, iterator: contractMonths });

        //console.info('-----------')
        setContractSerie({ name: t('Contract KM'), data: contract_serie });
    }, [csd, ced, km_month_contract, contractMonths])

    useEffect(() => {
        //console.info('effect forecastSeries')
        if (!forecastStrategy || !tracingSerie) return;
        //console.info('effect forecastSeries 1')
        if (!km_month_contract || !km_day_contract || !km_total_forecast_contract_day) return;
        //console.info('effect forecastSeries 2')
        if (!km_month_actual || !km_day_actual || !km_total_forecast_actual_day) return;
        //console.info('effect forecastSeries 3')
        if (!km_month_corrective || !km_day_corrective || !km_total_forecast_corrective_day) return;
        //console.info('effect forecastSeries 4')
        // if (!km_month_secondtolast || !km_day_secondtolast || !km_total_forecast_secondtolast_day) return;
        //console.info('effect forecastSeries 5')
        if (!ltd || !ltv || !months_from_lasttrace_to_end) return;
        //console.info('effect forecastSeries OK')


        let km_month_forecast;
        let km_day_forecast;
        let forecast_km;
        let actual_serie = [];


        if (forecastStrategy == "contract") {
            km_month_forecast = km_month_contract;
            km_day_forecast = km_day_contract;
            forecast_km = Math.round(km_total_forecast_contract_day);
        } else if (forecastStrategy == "actual") {
            km_month_forecast = km_month_actual;
            km_day_forecast = km_day_actual;
            forecast_km = Math.round(km_total_forecast_actual_day);
        } else if (forecastStrategy == "corrective") {
            km_month_forecast = km_month_corrective;
            km_day_forecast = km_day_corrective;
            forecast_km = Math.round(km_total_forecast_corrective_day);
        } else if (forecastStrategy == "secondtolast") {
            km_month_forecast = km_month_secondtolast;
            km_day_forecast = km_day_secondtolast;
            forecast_km = Math.round(km_total_forecast_secondtolast_day);
        }

        // converto il tracciato per usarlo in Apex
        for (let i = 0; i < tracingSerie?.length; i++) {
            let d = (new Date(tracingSerie[i].traced_at));
            actual_serie.unshift({ x: d.getTime(), y: parseInt(tracingSerie[i].value), date_past: d });
        }

        // inserisco la data di inizio contratto a zero
        actual_serie.unshift({ x: csd.getTime(), y: 0, date_past: csd });

        //let stepcorrector = 0;
        let prev_d = (new Date(ltd));
        let prev_km = ltv;

        for (let i = 0; i <= months_from_lasttrace_to_end; i++) {
            let d = (new Date(prev_d));
            d.setMonth(prev_d.getMonth() + 1);
            if (i == months_from_lasttrace_to_end) d.setDate(csd.getDate());

            let delta_days = (d - prev_d) / (1000 * 60 * 60 * 24);
            let km = parseInt(prev_km + (km_day_forecast * delta_days));

            actual_serie.push({ x: d.getTime(), y: km, date_future: d });

            //console.info(i + "/" + months_from_lasttrace_to_end, delta_days, "DISEGNO", km, d.toISOString(), "PRECEDENTE", prev_km, prev_d.toISOString(), "LAST TRACE", ltv, ltd.toISOString(), csd.toISOString());
            //console.info(i + "/" + months_from_lasttrace_to_end, forecastStrategy, "km", km, "prev_km", prev_km, "km_day_forecast", km_day_forecast, "delta_days", delta_days)
            prev_d = d;
            prev_km = km;
        }

        setKmTotalForecast(forecast_km);
        setKmMonthForecast(km_month_forecast);

        const costOrReimbursement = calculate(contractKilometers,
            forecast_km,
            contractCostKMExcess,
            contractKMReimbursement,
            contractPercentage1,
            contractCostKMExcess2,
            contractKMReimbursement2,
            contractPercentage2,
            contractCostKMExcess3,
            contractKMReimbursement3,
            contractPercentage3,
            contractKmDeductible,
            contractInitialMileage,
            contractMaxReimbursementAmount ?? 0
        );
        setKmCostForecast(costOrReimbursement)
        setForecastSerie({ name: t('Actual KM'), data: actual_serie });
    }, [forecastStrategy, tracingSerie, km_month_contract, km_day_contract, km_total_forecast_contract_day, km_month_actual, km_day_actual, km_total_forecast_actual_day, km_month_corrective, km_day_corrective, km_total_forecast_corrective_day, km_month_secondtolast, km_day_secondtolast, km_total_forecast_secondtolast_day, ltd, ltv, months_from_lasttrace_to_end]);


    useEffect(() => {
        //console.info('effect series finale')
        if (!contractSerie || !forecastSerie) return 
        //console.info('effect series finale OK')

        setSeries([contractSerie, forecastSerie]);
    }, [contractSerie, forecastSerie])

    useEffect(() => {
        //console.info('effect drawable finale')
        if (!series || !options) return 
        //console.info('effect drawable finale OK')

        setDrawable(true);
    }, [series, options])

    if (drawable) {
        // SCHIFEZZA NECESSARIA PERCHÈ SE LE SERIE DIFFERISCONO DI UN ELEMENTO IL GRAFICO SI DISEGNA MALE
        if (Math.abs(series[0].data.length - series[1].data.length) == 1) series[1].data.splice(1, 1);
    }

    const { control } = useForm({
        values: { 'input-select-strategy': forecastStrategy },
    });

    return (
        drawable && (
            <Box className="mtska-chart mtska-chart-vehicle-kilometer">
                <Box className="chartwrapper">
                    <ReactApexChart
                        type="area"
                        options={options}
                        series={series}
                        height="100%"
                    />
                </Box>
                <Box className="forecastwrapper">
                    <Select
                        id="input-select-strategy"
                        name="input-select-strategy"
                        value={forecastStrategy}
                        onChange={(e, v) => { setForecastStrategy(v) }}
                        variant="outlined"
                        autoComplete="off"
                        className="form-element-field form-element-field-select"
                    >
                        {
                            [
                                {
                                    label: t("Contract pace"),
                                    value: "contract",
                                },
                                {
                                    label: t("Actual pace"),
                                    value: "actual",
                                },
                                {
                                    label: t("Corrective pace"),
                                    value: "corrective",
                                },
                                {
                                    label: t("Short term pace"),
                                    value: "secondtolast",
                                }
                            ].map((option, k) => (
                                <Option key={k} value={option.value}>{option.label}</Option>
                            ))
                        }
                    </Select>

                    <Box className="result">
                        <Box className="info">
                            <span className='key'>{t('Actual KM')}<Icon onClick={() => { activate('tracekms/create', { car: item, legalEntity: item?.legalEntity, traceKmsLast: item?.traceKmsLast }) }} icon={'faCirclePlus'} family='fas' style={{ color: 'green', cursor: 'pointer', marginLeft: '5px' }} /></span>
                            <span className='value'>{formatDistance(ltv)}</span>
                        </Box>
                        <Box className="info">
                            <span className='key'>{t('Actual monthly KM')}</span>
                            <span className='value'>{formatDistance(km_month_actual)}</span>
                        </Box>
                        <Box className="info">
                            <span className='key'>{t('Contract monthly KM')}</span>
                            <span className='value'>
                                {!isNaN(km_month_contract) ? formatDistance(km_month_contract) : <Tag color={"danger"} title={t("Missing Contract KM")} onClick={handleRefineContract}><Icon icon="faWarning" />{t('Missing')}</Tag>}
                            </span>
                        </Box>
                        <Box className="info forecast">
                            <span className='key'>{t('Forecast total KM')}</span>
                            <span className='value'>{formatDistance(km_total_forecast)}</span>
                        </Box>
                        <Box className={"info forecast" + (km_month_forecast < km_month_contract ? ' warning' : '')}>
                            <span className='key'>{t('Forecast monthly KM')}</span>
                            <span className='value'>{formatDistance(km_month_forecast)}</span>
                        </Box>

                        {
                            !userCapabilities['auth/role.is_driver'] && (
                                <Box className={"info forecast" + (km_cost_forecast > 0 ? ' warning' : '')}>
                                    <span className='key'>{(km_cost_forecast > 0) ? t('Forecast cost KM') : t('Forecast refund')}</span>
                                    <span className='value'>
                                        {
                                            (km_cost_forecast > 0 && isNaN(contractCostKMExcess)) && (<Tag color={"danger"} title={t("Missing contractCostKMExcess")} onClick={handleRefineContract}><Icon icon="faWarning" />{t('Missing')}</Tag>)
                                        }
                                        {
                                            (km_cost_forecast <= 0 && isNaN(contractKMReimbursement)) && (<Tag color={"danger"} title={t("Missing contractKMReimbursement")} onClick={handleRefineContract}><Icon icon="faWarning" />{t('Missing')}</Tag>)
                                        }
                                        {
                                            ((km_cost_forecast > 0 && !isNaN(contractCostKMExcess)) || (km_cost_forecast <= 0 && !isNaN(contractKMReimbursement))) && !hasContractMaxReimbursementAmount && (formatCurrency(Math.round(km_cost_forecast * 100) / 100))
                                        }
                                        {
                                            ((km_cost_forecast > 0 && !isNaN(contractCostKMExcess)) || (km_cost_forecast <= 0 && !isNaN(contractKMReimbursement))) && hasContractMaxReimbursementAmount && ((Math.round(km_cost_forecast * 100) / 100) > contractMaxReimbursementAmount) && (formatCurrency(Math.round(km_cost_forecast * 100) / 100))
                                        }
                                        {
                                            ((km_cost_forecast > 0 && !isNaN(contractCostKMExcess)) || (km_cost_forecast <= 0 && !isNaN(contractKMReimbursement))) && hasContractMaxReimbursementAmount && ((Math.round(km_cost_forecast * 100) / 100) <= contractMaxReimbursementAmount) && (formatCurrency(contractMaxReimbursementAmount))
                                        }
                                    </span>
                                </Box>
                            )
                        }
                    </Box>
                </Box>
            </Box>
        )
    );
}

export default VehicleKilometer;